// extracted by mini-css-extract-plugin
module.exports = {"checkBoxHeaderContainer":"ServicesCostsAndInvoicesHistoryList_checkBoxHeaderContainer__3lxzT","monthHeaderCell":"ServicesCostsAndInvoicesHistoryList_monthHeaderCell__1Y53v"};